'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: white;\n  article, caption {\n    padding: 1rem;\n  }\n  max-width: 100vw;\n  overflow: auto;\n'], ['\n  background-color: white;\n  article, caption {\n    padding: 1rem;\n  }\n  max-width: 100vw;\n  overflow: auto;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Content = _styledComponents2.default.div(_templateObject);

exports.default = Content;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/overlay/content.js
// module id = 685
// module chunks = 0